import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=014d67a4&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=ts&"
export * from "./Projects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014d67a4",
  null
  
)

export default component.exports